export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11882.22827a2f.jpg";